// @ts-nocheck
/* The approved artist interview script (03 Website Redesign/artist-interview.html), ported 1:1 for /artist-interview.
   ZIGGEO_APP_TOKEN and SUBMIT_WEBHOOK_URL are intentionally empty: recordings stay in the browser (test mode)
   and Submit downloads the answers as a file. Fill them in to switch on Ziggeo uploads / the 1Dash.Pro webhook. */

export function initInterview(__root, __slug) {
  const __c = [];
  const __on = (t, e, f, o) => { t.addEventListener(e, f, o); __c.push(() => t.removeEventListener(e, f, o)); };

/* ================== SETTINGS (edit these) ================== */
const ZIGGEO_APP_TOKEN = "";   // <-- Ziggeo application token goes here (ONE place only)
const SUBMIT_WEBHOOK_URL = "";                  // <-- later: 1Dash.Pro inbound webhook URL. Empty = download only.
/* =========================================================== */

const USE_ZIGGEO = ZIGGEO_APP_TOKEN && ZIGGEO_APP_TOKEN !== "PASTE_TOKEN_HERE";

const QUESTIONS = [
 {q:"How long have you been tattooing, and how did you get started?", h:"Tell us your story in your own words."},
 {q:"What styles do you love doing most?", h:"Traditional, neo-trad, realism, black and grey, color, fine line, script, Japanese, anime and pop culture, horror, cover-ups... anything."},
 {q:"What styles will you NOT do, or would rather pass on?", h:"This helps us send you the right clients."},
 {q:"Tell us about the 3 to 5 pieces you are proudest of.", h:"What were they, and why do you love them?"},
 {q:"What is your dream project?", h:"The tattoo you would love someone to walk in with."},
 {q:"Who is your ideal client?", h:"What are they like? What do they want?"},
 {q:"What is your full-day rate? Your half-day rate? Your minimum for small pieces?", h:"Give us the numbers you charge."},
 {q:"How many days does a full sleeve, back, chest or leg usually take you?", h:"Give us your best guess for each one."},
 {q:"Which days are you open from October through December?", h:"Days of the week, or exact dates."},
 {q:"Do you do cover-ups?", h:"Yes, no, or case by case. Tell us what makes a good cover-up for you."},
 {q:"Is there anything clients should know before booking with you?", h:"Prep, placement, how you do the design process."},
 {q:"Is it OK to feature your work in Trip Ink ads, with your name and Instagram tagged?", h:"Tell us yes or no, and anything you want us to know."}
];
const STYLES = ["Traditional","Neo-traditional","Realism","Black & grey","Color","Fine line","Script / lettering","Japanese","Anime / pop culture","Horror","Cover-ups","Geometric","Watercolor","Blackwork","Portraits","Tribal / Polynesian"];
const PLACEMENTS = ["Arm","Forearm","Sleeve","Shoulder","Chest","Back","Ribs","Leg","Thigh","Calf","Hand","Neck","Other"];
const MONTHS = [{n:"October",m:9},{n:"November",m:10},{n:"December",m:11}];
const YEAR = 2026;

const $ = s => document.querySelector(s);
const state = {
  name:"", ig:"", idx:0,
  answers: QUESTIONS.map(()=>({text:"", video:null, audio:null, skipped:false, ziggeo:{video:null,audio:null}})),
  stylesDo:new Set(), stylesNo:new Set(), openDates:new Set(),
  photos:[]
};
let lastJSON = null;

function show(id){__root.querySelectorAll(".screen").forEach(s=>s.classList.remove("active"));$("#"+id).classList.add("active");window.scrollTo(0,0);}
function slug(s){return (s||"artist").toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"")||"artist";}

/* ---------- Welcome ---------- */
$("#startBtn").onclick = () => {
  const n = $("#artistName").value.trim(), ig = $("#artistIG").value.trim();
  if(!n){ $("#welcomeErr").textContent="Please type your name."; $("#artistName").focus(); return; }
  if(!ig){ $("#welcomeErr").textContent="Please type your Instagram."; $("#artistIG").focus(); return; }
  state.name=n; state.ig = ig.startsWith("@")?ig:"@"+ig.replace(/^https?:\/\/(www\.)?instagram\.com\//,"").replace(/\/$/,"");
  $("#welcomeErr").textContent="";
  state.idx=0; show("s-interview"); renderQuestion();
};

/* ---------- Local recorder (fallback when no Ziggeo token) ---------- */
const media = { stream:null, rec:null, chunks:[], kind:null, timer:null };

function stopStream(){ if(media.stream){media.stream.getTracks().forEach(t=>t.stop());media.stream=null;} }
function stopAllMedia(){
  try{ if(media.rec && media.rec.state!=="inactive"){ media.rec.onstop=null; media.rec.stop(); } }catch(e){}
  clearInterval(media.timer); stopStream(); media.rec=null;
}

function buildLocalRecorder(kind, host){
  const a = state.answers[state.idx];
  host.innerHTML = "";
  const stage = document.createElement("div"); stage.className="stage";
  const live = document.createElement(kind==="video"?"video":"audio");
  live.muted = true; live.playsInline = true; if(kind==="audio"){live.controls=false;live.className="hidden";}
  const status = document.createElement("div"); status.className="note"; status.style.marginTop=".5rem";
  const play = document.createElement(kind==="video"?"video":"audio"); play.controls=true; play.playsInline=true; play.className="hidden";
  stage.append(live, play, status);
  const row = document.createElement("div"); row.className="row"; row.style.marginTop=".8rem";
  const bStart = mk("Start recording","btn small"), bStop = mk("Stop","btn small ghost"), bRe = mk("Record again","btn small ghost");
  bStop.classList.add("hidden"); bRe.classList.add("hidden");
  row.append(bStart,bStop,bRe);
  host.append(stage,row);
  const note = document.createElement("div"); note.className="note";
  note.innerHTML = '<span class="badge">Test mode</span> Recordings stay on this page until you submit.';
  host.append(note);

  function showSaved(){
    const blob = a[kind];
    if(!blob){ status.textContent="Nothing recorded yet."; play.className="hidden"; live.className = kind==="video"?"":"hidden"; return; }
    play.src = URL.createObjectURL(blob); play.className=""; live.className="hidden";
    status.textContent = "Saved ("+(blob.size/1024/1024).toFixed(1)+" MB). Press play to check it.";
    bStart.classList.add("hidden"); bStop.classList.add("hidden"); bRe.classList.remove("hidden");
  }
  showSaved();

  bRe.onclick = () => { a[kind]=null; bRe.classList.add("hidden"); bStart.classList.remove("hidden"); play.pause(); showSaved(); updateState(); };
  bStart.onclick = async () => {
    status.textContent = "Asking for your "+(kind==="video"?"camera and microphone":"microphone")+"...";
    try{
      if(!navigator.mediaDevices || !window.MediaRecorder) throw new Error("unsupported");
      stopAllMedia();
      media.stream = await navigator.mediaDevices.getUserMedia(kind==="video"?{video:{facingMode:"user"},audio:true}:{audio:true});
      media.kind = kind; media.chunks = [];
      if(kind==="video"){ live.srcObject = media.stream; live.className=""; live.play().catch(()=>{}); }
      media.rec = new MediaRecorder(media.stream);
      media.rec.ondataavailable = e => { if(e.data && e.data.size) media.chunks.push(e.data); };
      media.rec.onstop = () => {
        a[kind] = new Blob(media.chunks,{type:media.rec.mimeType||(kind==="video"?"video/webm":"audio/webm")});
        stopStream(); clearInterval(media.timer); live.srcObject=null; showSaved(); updateState();
      };
      media.rec.start(500);
      bStart.classList.add("hidden"); bStop.classList.remove("hidden");
      let s=0; status.innerHTML='<span class="rec-dot"></span>Recording... 0:00';
      media.timer = setInterval(()=>{s++;status.innerHTML='<span class="rec-dot"></span>Recording... '+Math.floor(s/60)+":"+String(s%60).padStart(2,"0");},1000);
    }catch(err){
      status.textContent = "We could not open your "+(kind==="video"?"camera":"microphone")+". Please allow access in your browser, or type your answer instead.";
    }
  };
  bStop.onclick = () => { if(media.rec && media.rec.state!=="inactive") media.rec.stop(); bStop.classList.add("hidden"); };
}
function mk(txt,cls){const b=document.createElement("button");b.type="button";b.textContent=txt;b.className=cls;return b;}

/* ---------- Ziggeo (used only when a token is set) ---------- */
let ziggeoApp = null, ziggeoLoading = null;
function loadZiggeo(){
  if(ziggeoLoading) return ziggeoLoading;
  ziggeoLoading = new Promise((res,rej)=>{
    const l=document.createElement("link"); l.rel="stylesheet"; l.href="https://assets-cdn.ziggeo.com/v2-stable/ziggeo.css"; document.head.appendChild(l);
    const s=document.createElement("script"); s.src="https://assets-cdn.ziggeo.com/v2-stable/ziggeo.js";
    s.onload=()=>{ ziggeoApp = new ZiggeoApi.V2.Application({token:ZIGGEO_APP_TOKEN, webrtc:true, webrtc_streaming:true, webrtc_on_mobile:true}); res(ziggeoApp); };
    s.onerror=()=>rej(new Error("Ziggeo failed to load"));
    document.head.appendChild(s);
  });
  return ziggeoLoading;
}
function buildZiggeoRecorder(kind, host){
  const a = state.answers[state.idx], qn = state.idx+1;
  host.innerHTML = '<div class="note">Loading recorder...</div>';
  loadZiggeo().then(app=>{
    host.innerHTML = "";
    const el = document.createElement("div"); host.appendChild(el);
    const Ctor = kind==="video" ? ZiggeoApi.V2.Recorder : ZiggeoApi.V2.AudioRecorder;
    const attrs = {
      theme:"modern", themecolor:"red", width:"100%", allowupload:true,
      tags:[ "trip-ink-interview", slug(state.name), "q"+qn, kind ],
      "custom-data":{ artist:state.name, instagram:state.ig, question:qn, kind:kind },
      title: state.name+" - Q"+qn+" ("+kind+")"
    };
    const rec = new Ctor({element:el, attrs});
    rec.on("verified", ()=>{ const v = rec.get("video"); a.ziggeo[kind] = (v && (v.token||v)) || "uploaded"; updateState(); });
    rec.activate();
  }).catch(()=>{ host.innerHTML='<div class="err">The recorder did not load. Please type your answer instead.</div>'; });
}
function buildRecorder(kind, host){ USE_ZIGGEO ? buildZiggeoRecorder(kind,host) : buildLocalRecorder(kind,host); }

/* ---------- Interview ---------- */
let mode = "video";
function setMode(m){
  mode=m; stopAllMedia();
  document.querySelectorAll(".tab").forEach(t=>t.setAttribute("aria-selected", t.dataset.mode===m));
  ["video","audio","text"].forEach(k=>$("#p-"+k).classList.toggle("active",k===m));
  if(m==="video") buildRecorder("video",$("#p-video"));
  if(m==="audio") buildRecorder("audio",$("#p-audio"));
  if(m==="text") $("#typed").focus({preventScroll:true});
}
document.querySelectorAll(".tab").forEach(t=>t.onclick=()=>setMode(t.dataset.mode));
$("#typed").addEventListener("input",()=>{ state.answers[state.idx].text=$("#typed").value; state.answers[state.idx].skipped=false; updateState(); });

function hasAnswer(a){ return !!(a.text.trim()||a.video||a.audio||a.ziggeo.video||a.ziggeo.audio); }
function updateState(){
  const a = state.answers[state.idx];
  if(hasAnswer(a)) a.skipped=false;
  const bits=[]; if(a.video||a.ziggeo.video)bits.push("video"); if(a.audio||a.ziggeo.audio)bits.push("audio"); if(a.text.trim())bits.push("typed answer");
  $("#answerState").textContent = bits.length ? "Saved for this question: "+bits.join(", ")+"." : (a.skipped?"Skipped. You can come back to it.":"");
  renderDots();
}
function renderDots(){
  $("#dots").innerHTML = QUESTIONS.map((_,i)=>'<span class="'+(hasAnswer(state.answers[i])?'done ':'')+(i===state.idx?'cur':'')+'" title="Question '+(i+1)+'"></span>').join("");
}
function renderQuestion(){
  stopAllMedia();
  const i=state.idx, n=QUESTIONS.length;
  $("#progText").textContent="Question "+(i+1)+" of "+n;
  $("#progPct").textContent=Math.round(i/n*100)+"%";
  $("#progBar").style.width=(i/n*100)+"%";
  $("#qnum").textContent="Question "+(i+1);
  $("#qtext").textContent=QUESTIONS[i].q; $("#qhint").textContent=QUESTIONS[i].h;
  $("#typed").value=state.answers[i].text;
  $("#backBtn").disabled = false;
  $("#nextBtn").textContent = i===n-1 ? "Finish" : "Next";
  setMode(mode==="text"?"text":mode);
  updateState();
  window.scrollTo(0,0);
}
function go(d){
  stopAllMedia();
  const n=QUESTIONS.length, ni=state.idx+d;
  if(ni<0){ show("s-welcome"); return; }
  if(ni>=n){ $("#progBar").style.width="100%"; show("s-form"); buildForm(); return; }
  state.idx=ni; renderQuestion();
}
$("#backBtn").onclick=()=>go(-1);
$("#nextBtn").onclick=()=>go(1);
$("#skipBtn").onclick=()=>{ const a=state.answers[state.idx]; if(!hasAnswer(a)) a.skipped=true; go(1); };
$("#formBack").onclick=()=>{ state.idx=QUESTIONS.length-1; show("s-interview"); renderQuestion(); };

/* ---------- Final form ---------- */
let formBuilt=false;
function chipGroup(host,set){
  host.innerHTML="";
  STYLES.forEach(s=>{
    const b=document.createElement("button"); b.type="button"; b.className="chip"; b.textContent=s; b.setAttribute("aria-pressed",set.has(s));
    b.onclick=()=>{ set.has(s)?set.delete(s):set.add(s); b.setAttribute("aria-pressed",set.has(s)); };
    host.appendChild(b);
  });
}
function buildMonths(){
  const host=$("#monthPicker"); host.innerHTML="";
  MONTHS.forEach(mo=>{
    const wrap=document.createElement("div"); wrap.style.marginBottom=".8rem";
    const t=document.createElement("div"); t.className="lbl"; t.style.margin="0 0 .3rem"; t.textContent=mo.n; wrap.appendChild(t);
    const g=document.createElement("div"); g.className="chips";
    const days=new Date(YEAR,mo.m+1,0).getDate();
    for(let d=1;d<=days;d++){
      const key=YEAR+"-"+String(mo.m+1).padStart(2,"0")+"-"+String(d).padStart(2,"0");
      const b=document.createElement("button"); b.type="button"; b.className="chip"; b.style.minWidth="2.6rem"; b.style.padding=".3rem .5rem";
      b.textContent=d; b.title=mo.n+" "+d; b.setAttribute("aria-pressed",state.openDates.has(key));
      b.onclick=()=>{ state.openDates.has(key)?state.openDates.delete(key):state.openDates.add(key); b.setAttribute("aria-pressed",state.openDates.has(key)); };
      g.appendChild(b);
    }
    wrap.appendChild(g); host.appendChild(wrap);
  });
}
function buildForm(){
  if(formBuilt) return; formBuilt=true;
  chipGroup($("#chipsDo"),state.stylesDo); chipGroup($("#chipsNo"),state.stylesNo); buildMonths();
}
function renderPhotos(){
  const host=$("#photos"); host.innerHTML="";
  state.photos.forEach((p,i)=>{
    const d=document.createElement("div"); d.className="photo";
    const img=document.createElement("img"); img.src=p.url; img.alt=p.file.name; d.appendChild(img);
    const st=document.createElement("select"); st.setAttribute("aria-label","Style for photo "+(i+1));
    st.innerHTML='<option value="">Style...</option>'+STYLES.map(s=>'<option>'+s.replace(/&/g,"&amp;")+'</option>').join("");
    st.value=p.style; st.onchange=()=>p.style=st.value; d.appendChild(st);
    const pl=document.createElement("select"); pl.setAttribute("aria-label","Placement for photo "+(i+1));
    pl.innerHTML='<option value="">Where on the body...</option>'+PLACEMENTS.map(s=>'<option>'+s+'</option>').join("");
    pl.value=p.placement; pl.onchange=()=>p.placement=pl.value; d.appendChild(pl);
    const rm=mk("Remove","btn small ghost"); rm.onclick=()=>{state.photos.splice(i,1);renderPhotos();}; d.appendChild(rm);
    host.appendChild(d);
  });
  const c=state.photos.length;
  $("#photoCount").textContent = c+" photo"+(c===1?"":"s")+" added. "+(c<10?"Aim for 10 to 20.":(c>20?"That is more than 20. Pick your best 20 if you can.":"Nice."));
}
$("#photoInput").onchange=e=>{
  [...e.target.files].forEach(f=>{ if(f.type.startsWith("image/")) state.photos.push({file:f,url:URL.createObjectURL(f),style:"",placement:""}); });
  e.target.value=""; renderPhotos();
};

/* ---------- Submit ---------- */
function buildJSON(){
  return {
    submittedAt:new Date().toISOString(),
    artist:{name:state.name, instagram:state.ig},
    recordingMode: USE_ZIGGEO ? "ziggeo" : "local-test (recordings not uploaded)",
    interview: QUESTIONS.map((q,i)=>{
      const a=state.answers[i];
      return {number:i+1, question:q.q, skipped:a.skipped&&!hasAnswer(a), typedAnswer:a.text.trim(),
        video: a.ziggeo.video ? {ziggeoToken:a.ziggeo.video} : (a.video?{local:true,bytes:a.video.size,type:a.video.type}:null),
        audio: a.ziggeo.audio ? {ziggeoToken:a.ziggeo.audio} : (a.audio?{local:true,bytes:a.audio.size,type:a.audio.type}:null),
        ziggeoTags: USE_ZIGGEO ? ["trip-ink-interview",slug(state.name),"q"+(i+1)] : null};
    }),
    styles:{ love:[...state.stylesDo], other:$("#otherStyle").value.trim(), wontDo:[...state.stylesNo], wontDoNotes:$("#noNotes").value.trim() },
    rates:{ dayRate:$("#dayRate").value||null, halfDayRate:$("#halfRate").value||null },
    openDates:{ days:[...state.openDates].sort(), notes:$("#datesNotes").value.trim() },
    portfolioPhotos: state.photos.map(p=>({fileName:p.file.name, bytes:p.file.size, type:p.file.type, style:p.style, placement:p.placement})),
    tattoosICanDo: $("#canDo").value.split(/\n+/).map(s=>s.trim()).filter(Boolean),
    consentToFeatureInAds: $("#consent").checked
  };
}
function download(obj){
  const blob=new Blob([JSON.stringify(obj,null,2)],{type:"application/json"});
  const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
  a.download="trip-ink-interview-"+slug(state.name)+"-"+new Date().toISOString().slice(0,10)+".json";
  document.body.appendChild(a); a.click(); a.remove();
}
$("#submitBtn").onclick=async()=>{
  const err=$("#formErr"); err.textContent="";
  lastJSON=buildJSON(); window.__lastSubmission=lastJSON;
  download(lastJSON);
  let note="Your answers were saved as a file on your device.";
  if(SUBMIT_WEBHOOK_URL){
    try{
      const r=await fetch(SUBMIT_WEBHOOK_URL,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(lastJSON)});
      note = r.ok ? "Your answers were sent to Trip Ink." : "We could not send your answers (error "+r.status+"). Please text the downloaded file to the shop at 702-408-8305.";
    }catch(e){ note="We could not send your answers. Please text the downloaded file to the shop at 702-408-8305."; }
  }
  $("#thanksNote").textContent=note;
  $("#thanksName").textContent=state.name.split(" ")[0];
  show("s-thanks");
};
$("#dlAgain").onclick=()=>lastJSON&&download(lastJSON);

  __c.push(() => { try { stopAllMedia(); } catch (e) {} });
  return () => { __c.forEach((f) => { try { f(); } catch (e) {} }); };
}
